import React, { useEffect, useRef } from 'react';

export default function TwoFactorCodeInput({ value, onChange, disabled }) {
    const inputs = useRef([]);
    useEffect(() => { inputs.current[0]?.focus(); }, []);
    const insert = (text, position) => {
        const characters = text.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6).split('');
        const start = characters.length === 6 ? 0 : position;
        const next = [...value];
        if (!characters.length) next[position] = '';
        characters.forEach((character, index) => { if (start + index < 6) next[start + index] = character; });
        onChange(next);
        if (characters.length) inputs.current[Math.min(5, start + characters.length)]?.focus();
    };
    return <div className="access-code-inputs" role="group" aria-label="Código de verificação de seis caracteres">
        {value.map((character, index) => <input
            key={index}
            ref={element => { inputs.current[index] = element; }}
            type="text"
            inputMode="text"
            autoComplete={index === 0 ? 'one-time-code' : 'off'}
            autoCapitalize="characters"
            spellCheck={false}
            maxLength={6}
            value={character}
            disabled={disabled}
            aria-label={`Caractere ${index + 1} do código`}
            onFocus={event => event.target.select()}
            onChange={event => insert(event.target.value, index)}
            onPaste={event => { event.preventDefault(); insert(event.clipboardData.getData('text'), index); }}
            onKeyDown={event => {
                if (event.key === 'Backspace' && !character && index > 0) {
                    event.preventDefault();
                    const next = [...value]; next[index - 1] = ''; onChange(next);
                    inputs.current[index - 1]?.focus();
                }
                if (event.key === 'ArrowLeft' && index > 0) { event.preventDefault(); inputs.current[index - 1]?.focus(); }
                if (event.key === 'ArrowRight' && index < 5) { event.preventDefault(); inputs.current[index + 1]?.focus(); }
            }}
        />)}
    </div>;
}
